import { render, staticRenderFns } from "./authorizer.vue?vue&type=template&id=b255d924&"
import script from "./authorizer.vue?vue&type=script&lang=js&"
export * from "./authorizer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports